<template>
	<div>
		<nav-bar navBarTitle="会员兑换码"></nav-bar>
		<div class="vipCode" :class="{'navStyle':showNavbar}">
			<div class="vip-cell vip-code-cell" @click="show=true">
				<div class="vip-cell-title"><span>兑换码</span></div>
				<div class="vip-cell-value">
					<div class="vip-cell-body">
						<input type="text" placeholder="请输入兑换码" class="vip-field-control"  v-model="vipCode">
					</div>
				</div>
			</div>
			<div class="vip-code-btn">
				<div class="button code-btn-blue" @click="handleVipCode">立即兑换</div>
			</div>
			<div class="vip-code-desc">
				<h3>说明：</h3>
				<p class="text" v-for="(item, index) in desList" :key="index">{{ item.info }}</p>
			</div>
			<!--选择兑换码弹框-->
			<single-input-pop title="会员兑换码" :maxlength=16 @onSubmit="resolveInput" :show.sync="show" height="260px" :is-valid="true"></single-input-pop>
		</div>
	</div>
</template>

<script>
	import SingleInputPop from './components/SingleInputPop'
	import { useCode } from '../../api';
	import Toast from 'vant/es/toast';
	import { mapGetters, mapMutations } from 'vuex';
	import { checkEmojiRule } from '../../utils';

	export default {
		name: 'vipCode',
		data () {
			return {
				showNavbar: false,
				desList: [{
					info: '1、兑换码用于兑换政策补贴宝会员天数'
				},{
					info: '2、每个兑换码仅可用一次，重复使用无效'
				},{
					info: '3、兑换成功，VIP/SVIP立即生效至兑换账户中'
				}],
				vipCode: null,
				show: false,
			}
		},
		computed:{
			...mapGetters(['vipLevel'])
		},
		components: {SingleInputPop},
		mounted(){
			this.showNavbar = Number(localStorage.getItem('clearNav')) === 1 ? true : false
			this.originVipLevel = this.vipLevel
		},
		methods: {
			...mapMutations({
				'setVip': 'SET_VIP'
			}),
			resolveInput(value){
				if(checkEmojiRule(value)){
					Toast('不能输入表情')
					return false
				}
				this.vipCode = value
				this.show = !this.show
			},
			// 使用vipcode码
			handleVipCode() {
				if(!this.vipCode){
					Toast('请输入兑换码')
					return
				}
				// eslint-disable-next-line
				sensors.track('exchangeNowClick', {
					exchange_code: this.vipCode
				})
				useCode({code: this.vipCode}).then(res =>{
					if(res.ok){
						this.$store.dispatch('getMyPageInfo', {router: this.$router});
						this.setVip(res.data)
						this.$router.push({path: '/vip/successcode', query:{originVip:this.originVipLevel}})
					}else {
						Toast(res.msg)
					}
				})
			},
		},
	};
</script>

<style lang="less" scoped>
	.vipCode {
		padding: 30px 16px 16px 16px;
		.vip-code-cell{
			margin-top: 0;
		}
		.vip-code-btn {
			margin-top: 15px;
			.code-btn-blue{
				color: #ffffff;
				background: #398dff;
			}
		}
		.vip-code-desc {
			h3 {
				margin-top:30px;
				margin-bottom: 16px;
			}
			.text {
				font-size: 12px;
				line-height: 12px;
				color: #999999;
				margin-bottom: 10px;
			}
		}
	}
	/deep/ .van-action-sheet{
		padding: 0 20px;
		.van-action-sheet__header{
			text-align: left;
			color: @darkBlack;
		}

	}
	.vipCode.navStyle{
		padding-top: 16px;
	}

</style>
